import styled from '@emotion/styled';
import { css } from '@mui/material';

const StyledImagePreview = styled.img`
  width: 150px;
  height: auto;
  border: 1px solid #a2b2eb;
`;

interface IStyledPlaceholderPreview {
  extension: string;
}
const StyledPlaceholderPreview = styled.div<IStyledPlaceholderPreview>`
  width: 150px;
  height: 100px;
  border: 1px solid #a2b2eb;
  position: relative;

  &:after {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50px;
    height: 30px;
    padding-top: 5px;
    text-align: center;
    background-color: #7da7cc;

    ${(props: IStyledPlaceholderPreview) =>
      css`
        content: '${props.extension}';
      `}
  }
`;

const StyledAttachmentName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export { StyledImagePreview, StyledAttachmentName, StyledPlaceholderPreview };
